function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useEffect } from 'react';
import { useRefCallback, useSingleton } from '@bydesign-ui/hooks';
import { Schedule } from '../../../models/schedule';
export function useCreateSchedule(options) {
  var schedule = useSingleton(function () {
    return new Schedule();
  });

  var _options$value = options.value,
      value = _options$value === void 0 ? [] : _options$value,
      onValueChange = options.onValueChange,
      extra = _objectWithoutProperties(options, ["value", "onValueChange"]);

  schedule.updateOptions(extra);
  schedule.updateValue(value);
  var onValueChangeCallback = useRefCallback(onValueChange);
  useEffect(function () {
    schedule.addListener('value-change', onValueChangeCallback);
    return function () {
      schedule.removeListener('value-change', onValueChangeCallback);
    };
  }, []);
  return {
    schedule: schedule
  };
}